import { baseQuery } from '../baseQuery';

export const postVoipLogin = async () => {
  const { data } = await baseQuery('voip-login', {
    type: 'POST',
  });

  return data;
};
